<template>
    <div class="input input--text">
        <!--{{field}}-->

        <label
            v-if="field.field_label"
            :class="labelClass"
            v-html="field.field_label">
        </label>

        <input
            type="text"
            :value="siloData.user.modules[field.push_key]"
            :data-push-key="field.push_key"
            :placeholder="field.field_placeholder"
            :maxlength="field.max_chars"
            @keyup="$emit('validate')"
            data-watch-event="keyup"
            data-pristine-not-blank
            required
            >
    </div>
</template>

<script>
    export default {
        props: {
            field: Object,
            siloData: Object,
        },
        computed: {
            labelClass() {
                let returned = "";

                if (this.field.hide_label === true) {
                    returned += " screen-reader-only";
                }

                if (this.field.label_class !== undefined) {
                    returned += " " + this.field.label_class;
                } else {
                    returned += " type--label--italic";
                }

                return returned;
            },
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>

</style>